import { render, staticRenderFns } from "./QuizAnswerSheet.vue?vue&type=template&id=8d005c54&scoped=true&"
import script from "./QuizAnswerSheet.vue?vue&type=script&lang=js&"
export * from "./QuizAnswerSheet.vue?vue&type=script&lang=js&"
import style0 from "./QuizAnswerSheet.vue?vue&type=style&index=0&id=8d005c54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d005c54",
  null
  
)

export default component.exports